// import external dependencies
import 'jquery';
// Import everything from autoload
//
// Import components
import './components/homepage_lightbox';
import './components/desktop_nav_search';
import './components/expand';
import './components/key_campaigns_carousel';
import './components/home_mobile_leftnav';
import './components/quote_rotator';
import './components/resources';
import './components/skip_to_content';
import './components/accordion';
// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** 
 * Key Campaigns Height Equalizer - SMART VERSION
 * Uses tallest card but with reasonable limits to prevent extreme heights
 */
function initKeyCampaignsHeightEqualizer() {
  
  function equalizeKeyCampaignHeights() {
    const carousel = document.querySelector('.KeyCampaigns-campaigns');
    if (!carousel) return;
    
    const cards = carousel.querySelectorAll('.KeyCampaigns-campaign');
    if (cards.length === 0) return;
    
    // Reset heights first and let content flow naturally
    cards.forEach(card => {
      card.style.height = 'auto';
      card.style.minHeight = 'auto';
    });
    
    // Wait for content to settle
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        // Collect all heights after content has settled
        let heights = [];
        
        cards.forEach(card => {
          const cardHeight = card.offsetHeight;
          heights.push(cardHeight);
        });
        
        // Sort heights to analyze them
        heights.sort((a, b) => a - b);
        
        const minHeight = heights[0];
        const maxHeight = heights[heights.length - 1];
        const averageHeight = heights.reduce((sum, h) => sum + h, 0) / heights.length;
        
        // Determine reasonable maximum height
        // If the tallest card is more than 50% taller than average, cap it
        const heightDifference = maxHeight - averageHeight;
        const reasonableMax = averageHeight + (heightDifference * 0.6); // Only allow 60% of the excess
        
        // Use the smaller of: actual max height OR reasonable max
        const targetHeight = Math.min(maxHeight, reasonableMax);
        
        // But ensure it's at least as tall as the second-tallest card
        const secondTallest = heights.length > 1 ? heights[heights.length - 2] : maxHeight;
        const finalHeight = Math.max(targetHeight, secondTallest);
        
        // Apply the calculated height to all cards
        cards.forEach(card => {
          card.style.height = `${Math.round(finalHeight)}px`;
        });
        
        // Resize Flickity if it's initialized
        if (carousel.flickity && carousel.flickity.resize) {
          carousel.flickity.resize();
        }
        
        console.log(`Key Campaigns Heights:`, {
          original: heights,
          min: Math.round(minHeight),
          max: Math.round(maxHeight),
          average: Math.round(averageHeight),
          final: Math.round(finalHeight)
        });
      });
    });
  }
  
  // Wait for Flickity to initialize
  function waitForFlickityAndEqualize() {
    const carousel = document.querySelector('.KeyCampaigns-campaigns');
    if (!carousel) return;
    
    let attempts = 0;
    const maxAttempts = 50;
    
    function checkAndEqualize() {
      attempts++;
      
      if (carousel.classList.contains('flickity-enabled') || 
          carousel.flickity || 
          attempts >= maxAttempts) {
        
        // Wait a bit longer for Flickity and content to fully settle
        setTimeout(() => {
          equalizeKeyCampaignHeights();
        }, 200);
        
      } else {
        setTimeout(checkAndEqualize, 100);
      }
    }
    
    checkAndEqualize();
  }
  
  // Initialize the height equalizer
  waitForFlickityAndEqualize();
  
  // Re-equalize on window resize with debouncing
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(equalizeKeyCampaignHeights, 300);
  });
  
  // Re-equalize when images load
  const carousel = document.querySelector('.KeyCampaigns-campaigns');
  if (carousel) {
    const images = carousel.querySelectorAll('img');
    images.forEach(img => {
      if (!img.complete) {
        img.addEventListener('load', () => {
          setTimeout(equalizeKeyCampaignHeights, 100);
        });
        img.addEventListener('error', () => {
          setTimeout(equalizeKeyCampaignHeights, 100);
        });
      }
    });
  }
  
  // Make the function globally available for manual triggering
  window.equalizeKeyCampaignHeights = equalizeKeyCampaignHeights;
}

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => {
  routes.loadEvents();
  
  // Initialize Key Campaigns height equalizer
  initKeyCampaignsHeightEqualizer();
});


// WEBPACK FOOTER //
// ./scripts/main.js